import React, { useMemo } from 'react';
import { IOrderOption } from '../../types/accounting/IOrderOption';
import { IEscrowFileData } from '../../types/accounting/data/IEscrowFileData';
import styled from 'styled-components';
import { addressDataToString } from '../../ui-toolkit/orders/interfaces/IAddressResponse';
import { getBorrowerStringFromParties } from '../../ui-toolkit/orders/searchOrder/types/ISearchOrder';
import { eTransactionCategory } from '../../ui-toolkit/enums/eTransactionType';
import { useHasFeatureFlag } from '../../selectors/useHasFeatureFlag';

interface IOrderSelectHintTextProps {
  selectedOption: IOrderOption;
  escrowFile?: IEscrowFileData;
  error?: Error;
}

const BorrowerListWrapper = styled.div`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;

const getBankName = (isSpruceWithZillowEnabled: boolean, isZillowClosingEnabled: boolean, escrowFile?: IEscrowFileData, error?: Error): string => {
  if (error) {
    return `Error: ${error.message || 'There was an error getting bank name'}`;
  }
  const bank = escrowFile?.depositEscrowBankAccount;
  if (!bank) return '';
  const base = isSpruceWithZillowEnabled ? bank.legalName : bank.spruceName;
  const selectedNickname = isZillowClosingEnabled ? bank.nickname : bank.spruceNickname;
  return selectedNickname ? `${base} ${selectedNickname}` : base;
};

export const OrderSelectHintText: React.FC<IOrderSelectHintTextProps> = ({
  selectedOption: {
    data: { parties, propertyAddress, transactionCategory },
  },
  escrowFile,
  error,
}) => {
  const isSpruceWithZillowEnabled = useHasFeatureFlag('pinecone.spruce-with-zillow-closing');
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const bankName = useMemo(() => getBankName(isSpruceWithZillowEnabled, isZillowClosingEnabled, escrowFile, error), [escrowFile, error, isSpruceWithZillowEnabled, isZillowClosingEnabled]);

  return (
    <>
      Address: <strong>{addressDataToString(propertyAddress)}</strong>
      <br />
      <BorrowerListWrapper>
        {transactionCategory === eTransactionCategory.Purchase ? 'Buyers' : 'Borrowers'}:{' '}
        <strong>{getBorrowerStringFromParties(parties)}</strong>
      </BorrowerListWrapper>
      Bank: <strong>{bankName}</strong>
    </>
  );
};
